module.exports = __webpack_public_path__ + "site/img/102.23d9e81c.jpg";